module.exports = __webpack_public_path__ + "img/forest-orig.a67072be.jpg";